module.exports = __webpack_public_path__ + "static/media/momento_flajer.91a97979.jpg";